/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UserStatus {
    NOT_ACTIVE = 'NotActive',
    ACTIVE = 'Active',
    DISABLED = 'Disabled',
}
